module.exports = __webpack_public_path__ + "static/media/amazon.53ce77ad.png";